'use strict';
import angular from 'angular';
import snapPredefinedAudiencesHtmlUrl from './views/snapPredefinedAudiencesList.html';
import snapChildDataHtmlUrl from './views/snapPredefinedAudiencesRecursiveTemplate.html';
var app = angular.module('app.snapPredefinedAudiences.component', []);

app.component('snapPredefinedAudiences', {
    bindings: {
        showActions: '=',
        selectedSnapPredefinedAudiences: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId:'='
    },
    templateUrl: snapPredefinedAudiencesHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService) {
        var self = this;
        self.lifestyleList = [];
        self.snapChildDataHtmlUrl = snapChildDataHtmlUrl;

        self.IsChildObjectVisible = function(parent, child){
            var searchKey = $scope.search;
            var returnVal = true;
            if(undefined != searchKey && null != searchKey && searchKey.length > 0){
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function (item, child, selectedSnapPredefinedAudiences,indx,type) {
            if(type == "Lifestyles"){
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    var selIndex = selectedSnapPredefinedAudiences.lifestyles.indexOf(child);
                    var selIndex = _.findIndex(selectedSnapPredefinedAudiences.lifestyles, { id: child.id });
                    if (selIndex >= 0) {
                        selectedSnapPredefinedAudiences.lifestyles.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedSnapPredefinedAudiences.lifestyles.push(child);
                }
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if(e.id == item.id){
                    e.status = '';
                    e.isChecked = false;
                }
                if(e.childData && e.childData.length > 0){
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        var processLifestylesListData = function () {
            _.each(self.selectedSnapPredefinedAudiences, function (data) {
                _.each(data.lifestyles, function (item) {
                    _.each(data.lifestyleList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if(e.childData && e.childData.length > 0){
                            processSubLifestylesList(e.childData,data.lifestyles);
                        }
                    })
                })
            })
        }

        var processSubLifestylesList = function(childData,selectedLifestyles){
            _.each(selectedLifestyles,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if(e.childData && e.childData.length > 0){
                        processSubLifestylesList(e.childData,selectedLifestyles);
                    }
                })
            })
        }
        self.getLifestyles = function () {
            ProductService.getSnapLifestylesContent({ clientId:self.clientId,clusterId:self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var lifestyles = {};
                        lifestyles.id = content.id;
                        lifestyles.name = content.name;
                        lifestyles.status = "";
                        lifestyles.isChecked = false;
                        lifestyles.parentName = content.parentName;
                        lifestyles.childData = content.childData;
                        lifestyles.type = content.type;
                        self.lifestyleList.push(lifestyles);
                    });
                    _.each(self.selectedSnapPredefinedAudiences,function(item){
                        item.lifestyleList = angular.copy(self.lifestyleList);
                    })
                    processLifestylesListData();
                }
            }, function (error) { });
        }

        self.handleSelectLifestyles = function (lifestyle, selectedSnapPredefinedAudiences) {
            if (!lifestyle.isChecked) {
                lifestyle.status = '';
                lifestyle.isChecked = false;
                var selIndex = selectedSnapPredefinedAudiences.lifestyles.indexOf(lifestyle);
                if (selIndex >= 0) {
                    selectedSnapPredefinedAudiences.lifestyles.splice(selIndex, 1);
                } else {
                    if (selectedSnapPredefinedAudiences.lifestyles && selectedSnapPredefinedAudiences.lifestyles.length > 0) {
                        if (_.find(selectedSnapPredefinedAudiences.lifestyleList, { id: lifestyle.id })) {
                            var index = _.findIndex(selectedSnapPredefinedAudiences.lifestyleList, { id: lifestyle.id });
                            selectedSnapPredefinedAudiences.lifestyles.splice(index, 1);
                        }
                    }
                }
            } else {
                lifestyle.status = 'selected';
                lifestyle.isChecked = true;
                selectedSnapPredefinedAudiences.lifestyles.push(lifestyle);
            }
        }
        self.removeLifestyles = function (item, selectedLifestyles, lifestyleList) {
            var selIndex = selectedLifestyles.indexOf(item);
            if (selIndex >= 0) {
                selectedLifestyles.splice(selIndex, 1);
                self.clearSelectedData(item,lifestyleList);
            }
        }
        self.initComponent = function () {
            if (self.selectedSnapPredefinedAudiences && !_.isEmpty(self.selectedSnapPredefinedAudiences)) {
                self.selectedSnapPredefinedAudiences = JSON.parse(self.selectedSnapPredefinedAudiences);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getLifestyles();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedSnapPredefinedAudiences = [{
                    lifestyles: [],
                }];
                self.enableViewMode = false;
                self.getLifestyles();
            }
        };

        self.initComponent();
    }
});